<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('ticket_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-ticket</v-icon>{{ $t('ticket.number') }}{{ item['id'] }} - {{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-ticket-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td><strong>{{ $t('ticket.number') }}</strong></td>
              <td>
                <span v-if="item.priority.intensity >= 300 ">
                  <v-chip
                     class="ma-2"
                     color="error"
                     text-color="white"
                   >
                     {{ item['id'] }}
                   </v-chip>
                </span>
                <span v-else >
                  <v-chip
                     class="ma-2"
                   >
                     {{ item['id'] }}
                   </v-chip>
                </span>
              </td>
              <td><strong>{{ $t('global.title') }}</strong></td>
              <td>
                  {{ item['name'] }}
              </td>

            </tr>
            <tr>
              <td><strong>{{ $t('qualitycheck.product.customer') }}</strong></td>
              <td>
                  <router-link class="routerLink" :to="{ name: 'CustomerShow', params: { id: item['customer']['@id']}}">{{ item['customer'].name }}</router-link>
              </td>
              <td><strong>{{ $t('qualitycheck.product.product') }}</strong></td>
              <td>
                  <span v-if="item['product']">{{ item['product'].name }}</span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('contract.contracttype') }}</strong></td>
              <td colspan="3" v-if="item['product']">
                  <ul>
                    <li v-for="contract in contractInProgress" v-bind:key="contract.id">{{ contract.name }}</li>
                    <li v-for="contract in contractExpired" v-bind:key="contract.id">{{ contract.name + " (" + $t('contract.expired') + " le " + formatDateTime(contract.end, long) + ")"  }}</li>
                  </ul>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('contact.contact') }}</strong></td>
              <td colspan="3">
                  <span v-if="item['contact']">{{ item['contact'].name }} - <v-icon >mdi-mail</v-icon> <a v-if="item['contact'].email" :href=" 'mailto:' + item['contact'].email" >{{ item['contact'].email }}</a> - <v-icon >mdi-phone</v-icon> <a v-if="item['contact'].phone" :href=" 'tel:' + item['contact'].phone" >{{ item['contact'].phone }}</a> </span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('ticket.ticketorigin') }}</strong></td>
              <td>
                  <span v-if="item['origin']">{{ item['origin'].name }}</span>
              </td>
              <td><strong>{{ $t('ticket.ticketstatus') }}</strong></td>
              <td>

                  <v-chip
                    class="ma-1 font-weight-bold"
                    label
                    :color="statuscolor(item['status'])"
                  >
                    <v-icon left v-if="item['status'].init">
                      mdi-new-box
                    </v-icon>
                    <v-icon left v-if="item['status'].finish">
                      mdi-flag-checkered
                    </v-icon>
                    <v-icon left v-if="! item['status'].finish && ! item['status'].init">
                      mdi-cached
                    </v-icon>
                    <span v-if="language == 'fr'">{{ item['status'].namefr }}</span>
                    <span v-else>{{ item['status'].name }}</span>

                  </v-chip>
              </td>

            </tr>
            <tr>
              <td><strong>{{ $t('ticket.bugtype') }}</strong></td>
              <td>
                  <span v-if="item['bugType']">{{ item['bugType'].name }}</span>
              </td>
              <td><strong>{{ $t('ticket.assigned') }}</strong></td>
              <td>
                  <span v-if="item['assigned']">{{ item['assigned'].login }}</span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('ticket.tags') }}</strong></td>
              <td >
                <div id="tags">
                <v-chip v-for="tag in item['tags']" :key="tag.id"
                  class="ma-1 font-weight-bold"

                    color="secondary"
                  >
                    {{ tag.name }}
                  </v-chip>
                </div>
              </td>
              <td><strong>{{ $t('priority.priority') }}</strong></td>
              <td>
                  <span v-if="item['priority']">{{ item['priority'].name }}</span>
              </td>

            </tr>
            <tr>
              <td><strong>{{ $t('global.created') }}</strong></td>
              <td>
                  {{ formatDateTime(item['created'], 'long') }}
              </td>
              <td><strong>{{ $t('global.createdby') }}</strong></td>
              <td>
                  <span v-if="item['createdBy']">{{ item['createdBy'].login }}</span>
              </td>

            </tr>
            <tr>
              <td><strong>{{ $t('global.updated') }}</strong></td>
              <td>
                  {{ formatDateTime(item['updated'], 'long') }}
              </td>
              <td><strong>{{ $t('global.updatedby') }}</strong></td>
              <td>
                  <span v-if="item['updatedBy']">{{ item['updatedBy'].login }}</span>
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('ticket.datebug') }}</strong></td>
              <td>
                  {{ formatDateTime(item['dateBug'], 'long') }}
              </td>
              <td><strong>{{ $t('ticket.dateend') }}</strong></td>
              <td>
                  {{ formatDateTime(item['dateEnd'], 'long') }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('ticket.content') }}</strong></td>
              <td colspan="3" class="tablehtmleditor" v-html="item['description']" >
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('ticket.resolution') }}</strong></td>
              <td>
                  {{ item['resolution'] }}
              </td>
              <td><strong>{{ $t('ticket.timeWork') }}</strong></td>
              <td>
                  {{ item['timeWork'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('ticket.newrelease') }}</strong></td>
              <td>
                <span v-if="item.newrelease" class="mr-2"><v-icon color="green">mdi-check-circle</v-icon></span>
                <span v-else class="mr-2"><v-icon color="red">mdi-close-circle</v-icon></span>
              </td>

            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <template>
        <div class="ticketaction-list">
          <Toolbar
            :handle-add="() => addHandlerSub('Ticketaction',item)" v-if="userHasAccess('ticketaction_edit')"
          />
          <v-container grid-list-xl fluid>
            <v-layout row wrap>
              <v-flex sm12 >
                <h2>{{$t('ticket.ticketaction')}}</h2>
              </v-flex>
              <v-flex lg12>
                <v-data-table
                  v-model="selected"
                  :headers="headers"
                  :items="items"
                  :loading="isLoading"
                  :loading-text="$t('global.loading')"
                  :options.sync="options"
                  :server-items-length="totalItems"
                  class="elevation-1"
                  item-key="@id"
                  @update:options="onUpdateOptions"
                >
                <template slot="item.date" slot-scope="{ item }">
                  {{ formatDateTime(item['date'], 'long') }}
                </template>
                <template slot="item.type" slot-scope="{ item }">
                  <v-chip  class="ma-1 font-weight-bold"  label  color="secondary" v-if="language == 'fr'">
                    <v-icon left v-if="item['type'].public">mdi-eye</v-icon>
                    <v-icon left v-else>mdi-eye-off</v-icon>
                    {{ item['type'].namefr }}
                  </v-chip>
                  <v-chip  class="ma-1 font-weight-bold"  label  color="secondary" v-else>
                    <v-icon left v-if="item['type'].public">mdi-eye</v-icon>
                    <v-icon left v-else>mdi-eye-off</v-icon>
                    {{ item['type'].name }}
                  </v-chip>
                </template>
                <template slot="item.content" slot-scope="{ item }">
            <span  class="tablehtmleditor" v-html="item['content']"></span>         
          </template>
                      <ActionCell v-if="props.item['file']"
                      slot="item.action"
                      slot-scope="props"
                      :handle-show="() => showHandlerSub(item,'Ticketaction',props.item)"
                      :handle-download="() => downloadFileList(props.item['id'],props.item['@entity'],props.item['file'].filePath)"
                      ></ActionCell>
                      <ActionCell v-else
                      slot="item.action"
                      slot-scope="props"
                      :handle-show="() => showHandlerSub(item,'Ticketaction',props.item)"
                      ></ActionCell>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </template>
    </div>
    <Loading :visible="isLoading" />
  </div>
</template>

<script>

import i18n from '../../i18n.js';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import FileMixin from '../../mixins/FileMixin';
import Toolbar from '../../components/Toolbar';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';

const servicePrefix = 'Ticket';

export default {
  name: 'TicketShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ActionCell
  },
  data() {
    return {
      headers: [
        { text: this.$t('global.date'), value: 'date' },
        { text: this.$t('global.createdby'), value: 'createdBy.login' },
        { text: this.$t('ticket.actiontype'), value: 'type' },
        { text: this.$t('ticket.content'), value: 'content' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],

      filters: {
        'ticket' : this.$route.params.id,
      //  ...mapGetters('toolhead', { 'toolHead.id': 'find' }),
      },
      selected: [],
      footer: {
      'itemsPerPageText': "",
      },
      options: {sortBy : ['date'], sortDesc : [true]}
    };
  },
  mixins: [ShowMixin,AccessMixin,ListMixin,FileMixin],
  computed: {
    contractInProgress: function () {
      return this.item['product'].contracts.filter(function (contract){
        return new Date(contract.end) > new Date();
      })},
      contractExpired: function () {
      return this.item['product'].contracts.filter(function (contract){
        return new Date(contract.end) < new Date();
      })
    },
    ...mapFields('ticket', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('ticket', ['find']),
    ...mapGetters('ticketaction', {
      items: 'list'
    }),
    ...mapFields('ticketaction', {
      isLoading: 'isLoading'
    }),
    ...mapFields('ticketaction', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    language() {
      return i18n.locale;
    }
  },
  methods: {
    ...mapActions('ticket', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),
    ...mapActions('ticketaction', {
      getPage: 'fetchAll',
    }),
    showHandlerSubEvent(value) {
      this.showHandlerSub(this.item,'Ticketaction',value);
    },
    statuscolor(status) {
      if (status.important) {
        return 'error';
      }
      if (status.init) {
        return 'primary';
      }
      if (status.finish) {
        return 'success';
      }
      return 'accent';
    }
  }
};
</script>